import { Controller } from '@hotwired/stimulus';

import Checkout from '@/modules/checkout';
import Coupon from '@/modules/coupon';
import Helper from '@/modules/helper';
import ModuleLoader from '@/modules/module_loader';

export default class extends Controller {
  connect() {
    this.options = ModuleLoader.getOptions();
    this.enrolls = document.querySelectorAll('[data-enroll]');
    this.fieldsEmail = $('[data-ticket-email]');
    this.fieldsName = $('[data-ticket-name]');
    this.items = document.querySelectorAll('[data-item-id]');
    this.reservedUntil = Date.parse(this.options.reserved_until);
    this.time = $('[data-time]');
    this.trailsCheckboxes = document.querySelectorAll('[data-trail]');

    new Checkout(this.options).create();

    this.#bindCountdown();
    this.#bindPast();
    this.#bindTrailEnroll();

    new Coupon({ itemIds: this.#itemIds(), itemType: 'Ticket', namespace: 'event' }).init();
  }

  #bindCountdown() {
    this.countdown = setInterval(() => this.#updateCountdown(), 1000);
  }

  #bindPast() {
    this.fieldsName.on('focusout', (event) => {
      for (let i = 0; i < this.fieldsName.length; i++) {
        if (this.fieldsName != event.currentTarget && this.fieldsName[i].value === '') {
          this.fieldsName[i].value = event.currentTarget.value;
        }
      }
    });

    this.fieldsEmail.on('focusout', (event) => {
      for (let i = 0; i < this.fieldsEmail.length; i++) {
        if (this.fieldsEmail != event.currentTarget && this.fieldsEmail[i].value === '') {
          this.fieldsEmail[i].value = event.currentTarget.value;
        }
      }
    });
  }

  #bindTrailEnroll() {
    for (const checkbox of this.trailsCheckboxes) {
      checkbox.addEventListener('change', this.#onTrailEnrollChange);
    }

    for (const item of this.enrolls) {
      $(item).checkony({ item: '[type="checkbox"]', max: parseInt(item.dataset.examLimit, 10), type: 'checkbox' });
    }
  }

  #displayTime(milliseconds) {
    this.time.text(new Date(milliseconds).toISOString().substr(14, 5));
  }

  #itemIds() {
    return Array.from(this.items).map((el) => el.dataset.itemId);
  }

  #onTrailEnrollChange(event) {
    const checkbox = event.target;
    const sameCheckboxes = document.querySelectorAll(`[data-trail="${checkbox.dataset.trail}"]`);

    for (const item of sameCheckboxes) delete item.dataset.ignore;

    checkbox.dataset.ignore = true;

    for (const item of sameCheckboxes) {
      if (!item.dataset.ignore) item.checked = false;
    }
  }

  #updateCountdown() {
    const timeLeft = Math.max(0, this.reservedUntil - Date.now());

    this.#displayTime(timeLeft);

    if (timeLeft === 0) {
      clearInterval(this.countdown);

      Helper.goTo(this.options.timeout_uri);
    }
  }
}
